import { useIntl } from "@leagueplatform/locales";
import { EXTERNAL_LINKS } from "common/links";
import { FooterLinkProps } from "@leagueplatform/solutions-foundation";

export const useAppFooterLinks = () => {
  const { formatMessage } = useIntl();

  const footerLinks: FooterLinkProps[] = [
    {
      text: formatMessage({ id: "STR_TERMS_OF_SERVICE" }),
      url: EXTERNAL_LINKS.TERMS,
    },
    {
      text: formatMessage({ id: "STR_PRIVACY_POLICY" }),
      url: EXTERNAL_LINKS.PRIVACY,
    },
    {
      text: formatMessage({ id: "STR_NON_DISCRIMINATION_NOTICE" }),
      url: EXTERNAL_LINKS.NON_DISCRIMINATION_NOTICE,
    },
  ];

  return {
    footerLinks,
  };
};
